export class LoaderError extends Error {
	readonly cause: unknown;

	constructor(cause: unknown) {
		super('Loadable: chunk load failed');
		this.name = 'LoaderError';
		this.cause = cause;
	}
}
